import React, {useEffect} from 'react';

import {hooks} from '../../hooks';
import {components} from '../../components';
import {actions} from '../../store/actions';
import {salon} from '../../config/salon';

export const Location: React.FC = () => {
  const dispatch = hooks.useDispatch();

  hooks.useThemeColor('#FFF7F4');

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(actions.setColor('#FFF7F4'));
  }, [dispatch]);

  return (
    <>
      <components.Header
        title='Konum'
        showLogo={true}
        showBasket={true}
        headerStyle={{backgroundColor: 'var(--main-background)'}}
      />
      <main className='scrollable salon-main salon-main--quiet'>
        <components.HeroSlider />
        <section className='salon-section'>
          <span className='salon-eyebrow'>Nilüfer / Bursa</span>
          <h2>Salon Adresi</h2>
          <p className='salon-section__text'>{salon.address}</p>
          <iframe
            className='salon-map-frame'
            src={salon.mapsEmbedHref}
            loading='lazy'
            title='Çağla Karagiray The Most Beauty konumu'
          />
          <div className='salon-actions'>
            <a
              className='salon-button salon-button--dark'
              href={salon.mapsHref}
              target='_blank'
              rel='noreferrer'
            >
              Yol Tarifi Al
            </a>
            <a
              className='salon-button salon-button--outline'
              href={salon.phoneHref}
            >
              Ara
            </a>
          </div>
        </section>
      </main>
      <components.QuickContact />
      <components.Footer />
    </>
  );
};
